import React from "react"
import styled from "styled-components"

import { media } from "@styles/breakpoints"

const Logo = ({ light, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="160"
    height="23"
    viewBox="0 0 160 23"
    {...props}
  >
    <g>
      <path
        fill="#22313E"
        fillRule="evenodd"
        d="M19.676 4.438h-.057l-7.348 18.555L4.947 4.438h-.056l-3.606 17.85H0L4.528.02l7.743 19.628L20.038.02l4.528 22.267h-1.285l-3.605-17.85zM42.542 20.03c-1.898 1.586-4.313 2.544-6.905 2.544-5.926 0-10.93-5.01-10.93-11.075 0-6.065 4.976-11.071 10.93-11.071 2.599 0 5.01.954 6.904 2.533C44.435 1.382 46.848.43 49.447.43c5.954 0 10.93 5.01 10.93 11.071 0 6.065-5.004 11.075-10.93 11.075-2.592 0-5.008-.958-6.905-2.544zm-.904-.844a9.492 9.492 0 01-4.15 1.975 9.384 9.384 0 01-5.543-.572 9.642 9.642 0 01-4.296-3.629 9.98 9.98 0 01-1.6-5.461c.03-2.59 1.05-5.066 2.843-6.894a9.559 9.559 0 016.745-2.887 9.432 9.432 0 015.96 2.127 11.096 11.096 0 00-3.08 7.654c0 2.97 1.2 5.687 3.12 7.687zm1.808 0a9.538 9.538 0 002.31 1.403 9.384 9.384 0 005.542.572 9.522 9.522 0 004.917-2.678 9.887 9.887 0 002.633-5.024 10.03 10.03 0 00-.54-5.675 9.768 9.768 0 00-3.53-4.41 9.432 9.432 0 00-5.331-1.656 9.532 9.532 0 00-5.94 2.151c1.888 1.994 3.06 4.688 3.06 7.63 0 2.97-1.2 5.687-3.12 7.687zm-.881-14.439a9.84 9.84 0 011.933 3.037c.725 1.795.913 3.77.54 5.675a9.892 9.892 0 01-2.496 4.882 9.768 9.768 0 01-1.083-1.38 9.98 9.98 0 01-1.6-5.462 10.017 10.017 0 012.706-6.752zm38.438 18.256L63.31 3.748v18.555h-1.341V.45l17.694 19.075V.717h1.341v22.287zm22.842-20.351a9.652 9.652 0 013.183 2.468l-.004-1.897a10.345 10.345 0 00-6.986-2.803c-5.982 0-11.014 4.98-11.014 11.1 0 6.036 5.116 11.046 10.986 11.046a10.796 10.796 0 007.014-2.692v-1.889c-1.563 1.954-4.653 3.299-7.07 3.299-2.49 0-5.004-1.258-6.764-2.973a9.398 9.398 0 01-2.066-3.044 9.58 9.58 0 01-.754-3.624c0-5.29 4.33-9.925 9.588-9.925 1.345.03 2.669.348 3.887.934zM111.725 21h5.366v1.287h-6.707V.717h1.341V21zm9.133-11.162V2.004h8.722V.717h-10.071v21.565h10.071v-1.286h-8.722v-9.871h8.496V9.838h-8.496zm22.705 12.449h-1.538l-6.873-10.214h-.673v10.214h-1.342V.717h2.627c1.708 0 3.384.03 4.81 1.085 1.507 1.088 2.123 2.804 2.123 4.634 0 3.749-2.542 5.695-6.043 5.637l6.909 10.214zm-7.396-11.5c1.313 0 2.631-.058 3.69-1.002.48-.418.863-.941 1.12-1.53.256-.59.38-1.231.363-1.876 0-1.6-.725-3.204-2.236-3.889-1.023-.497-2.298-.492-3.451-.487h-1.19v8.784h1.704zM159.355.717h-1.788l-9.987 10.07V.717h-1.342v21.57h1.338V12.55l.56-.573 10.12 10.309h1.76L149.058 11.1 159.355.717z"
        clipRule="evenodd"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" d="M0 0H160V23H0z"></path>
      </clipPath>
    </defs>
  </svg>
)


const MoonClerk = styled(Logo)`
  transform: scale(0.9);
  
  ${media.sm`
    transform: scale(1);
  `}

  g path {
    fill: ${props => (props.light ? "var(--gray--00)" : "var(--gray--100)")};
  }
`

export default MoonClerk
